import 'babel-polyfill';
import 'react-app-polyfill/stable';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";
import GlobalData from './tools/GlobalData';
import UserAnalytics from './components/User/Analytics/UserAnalytics'
import "antd/dist/antd.css";

//javascript
//import postscribe from 'postscribe';
//pe Edge 40 nu afiseaza nici un mesaj de eroare - noroc ca il afisez eu la !browser_ok
	//import ScriptTag from 'react-script-tag';
	//yarn add react-script-tag
	//NO import detect_browser from "./detect_browser", only from /public/...;

//blank screen on Edge 40 (declared 15, Chrome 52)
	//compiling and declaring APP kills Edge 40
	//import App from './App';
	//import index_react from './index_react';
//compile on Edge 40
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import './index_stripe.css';

function console_log( ...args){
	GlobalData.Console_log( ...args);
}
function console_log_err( ...args){
	GlobalData.Console_log_err( ...args);
}

const App = React.lazy(() => import('./App'));

try{
	//console_log( "index DOC", document);
	//console_log( "index DOC", document.location);
	console_log( "index DOC Location Origin", document.location.origin);
}catch( err){
	console_log_err( "index DOC Location Origin ERR", err);
}

let browser_info = "";
let browser_status_info = "";
let browser_ok = true;
let alert_browser = false;
let search = window.location.search;
let detect_browser = search && search.includes("browser=show"); //false;
console_log( "index search", search);

const Videnda_AI_START_APP = "Videnda AI START App";
const Videnda_AI_Application_Started_str = "Application started";

const Chrome_Minimum_Version = 68;// 68; //incredibil dar merge cu Suspense App
const Edge_Minimum_Version = 46; //tested 90, 91 on flex5 and dell and 46(EdgA) on P20 Pro
const Opera_Minimum_Version = 57; //tested 58 on HP iPad, 63 on P2Pro, P40Pro
const Safari_Minimum_Version = 13; //tested 13 and 14
const Firefox_Minimum_Version = 80; //tested 88, 89 OK, 46 NO = Dead, no Alert
const Huawei_Minimum_Version = 10; //tested 11 ok on P20
const Facebook_Minimum_Version = 200; //tested 293 ok on P20
	//Facebook Mobile Browser
	//FB_IAB/FB4A;FBAV/293.0.0.43.120
	//all versions here = https://user-agents.net/applications/facebook-app
const Samsung_Minimum_Version = 12; //tested 11 DEAD on S7, Beta 5.4 DEAD
	//tested 14.0.3.5 OK pe S7
	//tested Samsung 10 si 14 la terasa cu Andrei ????



function set_browser_ok( bok, browser_status_info){
	browser_ok = bok;
	if( !bok){ //browser rejected
		//save bok, browser_status_info to DB
		//let user press a "Retry" button to start again
	}
}


//called NOW
function local_storage_works(){
	let key_str = "test_local_storage";
	let value_str = "test_1001";
	window.localStorage.setItem( key_str, value_str);
	let value_str_found = window.localStorage.getItem( key_str);
	if( value_str === value_str_found)
		return true;
	return false;
}

const browser_key_str = "alert_if_browser_ok";
const browser_key_value = "Done Already 1002";
function get_alert_if_browser_ok(){
	if( ! local_storage_works())
		return false; //no Local Storage no alert
	let alert_if_browser_ok = window.localStorage.getItem( browser_key_str);
	//if( alert_if_browser_ok)
	//	return false;
	if( browser_key_value !== alert_if_browser_ok)
		return true; //no match = Alert = TRUE
	//same values - stop alerting
	return false; //first time, no data here
}

function send_info_to_db( from, tip, info){
	let alert_if_browser_ok = window.localStorage.getItem( browser_key_str);
	if( browser_key_value === alert_if_browser_ok)
		return true; //EXIT already sent data
	const userAnalytics = new UserAnalytics();
	//const from = "index.js";
	//const tip = "browser rejected";
	if( userAnalytics)
		userAnalytics.event( from, tip, info);
}

var detect_aplication_freeze_start = (function(){
	//alert("app START");
	let start_add = window.localStorage.getItem( Videnda_AI_START_APP);
	if( Videnda_AI_Application_Started_str === start_add){
		alert_browser = true;
		//alert("app reloaded in browser");
	}else
		window.localStorage.setItem( Videnda_AI_START_APP, Videnda_AI_Application_Started_str);
})();

//called LATER
var detect_aplication_freeze_end = (function(){
	window.localStorage.removeItem( Videnda_AI_START_APP, 'Application started');
});

//called NOW
var get_browser = (function() {
	browser_status_info += "ls=" + local_storage_works();
	browser_status_info += "(s)" + navigator.userAgent
    var ua = navigator.userAgent,
            tem,
            M =
                ua.match(
                    /(opera|chrome|crios|safari|firefox|edga|edg|opr|huaweibrowser|samsungbrowser|fbav|msie|trident(?=\/))\/?\s*(\d+)/i
                ) || [];
	//browser_status_info += "(t)" + tem; //ua --> M
	browser_status_info += "(m)" + M;
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return { name: "IE", version: tem[1] || "" };
    }

    if (M[1] === "Chrome") {
		browser_status_info += "[Chrome]"
        tem = ua.match(/\b(OPR|Edge|EdgA|Edg|HuaweiBrowser|SamsungBrowser|FBAV)\/(\d+)/);
        if (tem != null) {
			let name_x = tem[1].replace("OPR", "Opera");
			let version_x = tem[2];
			browser_status_info += ",name_x=" + name_x;
			browser_status_info += ",version_x=" + version_x;
            //return { name: tem[1].replace("OPR", "Opera"), version: tem[2] };
			if( "Edge" === name_x || "Edg" === name_x || "EdgA" === name_x){
				browser_info += name_x + " version=" + version_x;
				//current 2021-june-2 = Version 91.0.864.37 (Official build) (64-bit)
				if( version_x < Edge_Minimum_Version)
					set_browser_ok( false, browser_status_info);
				return;
			}
			if( "FBAV" === name_x){
				browser_info += name_x + " version=" + version_x;
				if( version_x < Facebook_Minimum_Version)
					set_browser_ok( false, browser_status_info);
				return;
			}
			if( "Opera" === name_x || "OPR" === name_x){
				browser_info += name_x + " version=" + version_x;
				//current 2021-june-2 = Version 91.0.864.37 (Official build) (64-bit)
				if( version_x < Opera_Minimum_Version)
					set_browser_ok( false, browser_status_info);
				return;
			}
			if( "HuaweiBrowser" === name_x){
				browser_info += name_x + " version=" + version_x;
				//current 2021-june-2 = Version 91.0.864.37 (Official build) (64-bit)
				if( version_x < Huawei_Minimum_Version)
					set_browser_ok( false, browser_status_info);
				return;
			}
			if( "SamsungBrowser" === name_x){
				browser_info += name_x + " version=" + version_x;
				//current 2021-june-2 = Version 91.0.864.37 (Official build) (64-bit)
				if( version_x < Samsung_Minimum_Version)
					set_browser_ok( false, browser_status_info);
				return;
			}
        }
    }

	browser_status_info += ",(m2=)" + M[2];
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
	browser_status_info += ",(s1=)" + M;
	//browser_status_info += ",(na=)" + navigator.appName;
	//browser_status_info += ",(nv=)" + navigator.appVersion;

    //kills Facebook Mobile Browser (Chrome Version 86 --> 4 on my P20Pro)
    //FB_IAB/FB4A;FBAV/293.0.0.43.120
    //https://user-agents.net/applications/facebook-app
    //if ((tem = ua.match(/version\/(\d+)/i)) != null) {
    //    M.splice(1, 1, tem[1]);
    //}
	//browser_status_info += ",(s2=)" + M;

	console_log( "get browser", M);
	browser_info += " " + M[0] + " version=" + M[1] + " - ";

	browser_status_info += ",name_compare=[" + M[0] + "], version=[" + M[1]+ "]";
	if( "Safari" === M[0] && M[1] < Safari_Minimum_Version){
		//current 2021-june-3 = Version 13 on Mony iPhone 8
		set_browser_ok( false, browser_status_info);
	}
	if( ("Chrome" === M[0] || "CriOS" === M[0]) && M[1] < Chrome_Minimum_Version){
		//current 2021-june-2 = Version 91.0.4472.77 (Official Build) (64-bit)
		set_browser_ok( false, browser_status_info);
	}
	if( "Edge" === M[0] && M[1] < Edge_Minimum_Version){
		//current 2021-june-2 = Version 91.0.864.37 (Official build) (64-bit)
		set_browser_ok( false, browser_status_info);
	}
    return { name: M[0], version: M[1] };
    //return { name: "aa", version: "bb" };
})();

function getHideOnBrowserWeak(){
	if( browser_ok)
		return "buttons-to-show";
	return "buttons-to-hide";
}
function getHideOnBrowserOK(){
	if( browser_ok)
		return "buttons-to-hide";
	return "buttons-to-show";
}

//OLD version, unused
function old_render_page(){
	//return( "Please update your Browser from X");
	let info = browser_info + " [" + browser_status_info + "]";
	if( alert_browser || detect_browser){
		detect_aplication_freeze_end();
		alert( "Application was reloaded in brower = " + info);
	}
	if( !browser_ok){
		return( "Please update your Browser from " + info);
	}
//	if( browser_ok){
//		return( "Browser OK " + info);
//	}

	//ar fi util un HISTORY REDIRECT aici ca sa pot sa ma opresc la browsere vechi
	//ceva care sa compileze in alt fisier dar sa nu imi piarda parametrii de pe URL
	//citeste mai departe la link-ul
		//https://www.digitalminds.io/blog/detecting-outdated-browsers-in-vanilla-javascript
	return(
		"<script>go_to_react(){window.location='index_react.html'}</script>"
	);
}

	browser_info = browser_info.replace( /CriOS/g, "Chrome(CriOS)");
		browser_info = browser_info.replace( /EdgA/g, "Edge(EdgA) ");
		browser_info = browser_info.replace( /Edg /g, "Edge(Edg) ");
		browser_info = browser_info.replace( /FBAV /g, "Facebook(FBAV) ");
	let info = browser_info + " [" + browser_status_info + "]";
		info = info.replace( /CriOS/g, "Chrome(CriOS)");
		info = info.replace( /EdgA/g, "Edge(EdgA) ");
		info = info.replace( /Edg /g, "Edge(Edg) ");
		info = info.replace( /FBAV /g, "Facebook(FBAV) ");
	console_log("Application is running in", info);

	if( alert_browser || detect_browser){
		detect_aplication_freeze_end();
		alert( "Application was reloaded in brower = " + info);
	}
	if( browser_ok){
		send_info_to_db( "index", "browser OK", info);
	}else{
		if( get_alert_if_browser_ok()){
			//set_alert_if_browser_ok( false);
			send_info_to_db( "index", "browser rejected", "rejected ALERT on " + info);
			alert( "!!! Application may not load - Please update your Browser from " + info);
		}else
			send_info_to_db( "index", "browser rejected", "rejected NO ALERT on " + info);
		//load blank page
		//ReactDOM.render(
		//	"Please update your Browser from " + info
		//	,
		//	document.getElementById('root')
		//);
	}
	//stop ALERT and SEND BROWSER data to DB
	window.localStorage.setItem( browser_key_str, browser_key_value);

	//load program anyway - alert only once per app life (State and static do not work)
	//else //loading fails here if browser is old
	{
			ReactDOM.render(
				<BrowserRouter>
					<Suspense fallback={<div>Loading in Browser ... {browser_info}</div>}>
						  <App />
					</Suspense>
				</BrowserRouter>
				,
				document.getElementById('root')
			);
	}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console_log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

	reportWebVitals();
	detect_aplication_freeze_end();

/*
	<index_react />
	const script = document.createElement('script')
	script.src = 'index_react.js'
	document.head.append( script)

	ReactDOM.render(
		<div>
			{render_page()}
		</div>
		,
		document.getElementById('root')
	);
			<div className={getHideOnBrowserOK()}>
				Please update your Browser from {browser_info}
				<br/>{getHideOnBrowserOK()}
			</div>
			<div className={getHideOnBrowserWeak()}>
				Browser OK from {browser_info}
				<br/>{getHideOnBrowserWeak()}
			</div>
		<script>
			var $buoop = {required:{e:-4,f:-3,o:-3,s:-1,c:-6},insecure:true,unsupported:true,api:2021.06 };
			function $buo_f(){
			 var e = document.createElement("script");
			 e.src = "//browser-update.org/update.min.js";
			 document.body.appendChild(e);
			};
			try {document.addEventListener("DOMContentLoaded", $buo_f,false)}
			catch(e){window.attachEvent("onload", $buo_f)}
		</script>
		<App />
		postscribe('#mydiv', '<script src="detect_browser_v1.js"></script>');
	try{
		//yarn add postscribe
		postscribe('#mydiv', '<script>document.getElementById("mydiv").innerHTML = "Hello JavaScript!";</script>');
		//postscribe('#mydiv', '<script language="javascript" src="detect_browser.js"></script>');
		console_log( "index DOC postscribe OK");
	}catch( err){
		console_log( "index DOC postscribe ERR", err);
	}

	Uncaught SyntaxError: Unexpected token '<'
			'<html>404 Not Found</html>'
		<div id="mydiv">GiGi</div>
		<ScriptTag src="/buttons/detect_browser.js" />
		<App />
	document.getElementById('root')

//	ReactDOM.render(
//		<div>
//			<ScriptTag src="/buttons/detect_browser.js" />
//			<BrowserRouter>
//				<App />
//			</BrowserRouter>
//		</div>,
//		document.getElementById('root')
//	);
*/

/*
	return(
		<BrowserRouter>
			pana acum marele detect_browser nu m-a ajutat cu nimic - tot ce mi-am detectat singur
				<ScriptTag src="/buttons/detect_browser.js" />
			<App />
		</BrowserRouter>
		<BrowserRouter>
			<App /> {//kills Edge 40 = blank screen
				}
		</BrowserRouter>
	);
*/

/*
Somehow we need to call React in a different thread, after this process is done.
Because React will kill old browsers before the first instruction of this checking module is executed - the result is a blank screen with React activated and super message with React deactivated
There are some minor mistakes (because even navigator.userAgent has changed during years) for example:
Lumia 550 with Edge 40 declared by phone is declared by this module Edge 15 (or Chrome 52 at start). But this is a different issue, that can be fixed because just be detecting browser name we can Stop at versions (15,52,40) < (91 - 7) as they are now in Edge and Chrome

I tested the code and if you call React later it will start work - see my answer in thread - I will come back with a link to my site in 72h or maybe sooner
On android old Chrome 68 is heroically started both this module and React
On Edge 40 (Microsoft Mobile Lumia 550) you need to start only this module and react later. I had this experience with Microsoft even at mobile applications when trying "one package fits all" mobile solutions (Cordova Adobe) . The mobile app was published for years in Google Play and Apple Shop and crashed on Microsoft Mobile (and now is working in C# only from Visual Studio - I tested it today and had a nice feeling of seeing super old stuff up and running on super old Mobile Phones from my Garage :-) )


*/